import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlComponent } from './pl.component';
import {
  MatToolbarModule,
  MatSlideToggleModule,
  MatFormFieldModule,
  MatSelectModule,
  MatButtonModule,
  MatProgressSpinnerModule,
  MatIconModule,
  MatRadioModule,
  MatInputModule,
} from '@angular/material';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { PlOptionsComponent } from './views/pl-options/pl-options.component';
import { PlAggridComponent } from './views/pl-aggrid/pl-aggrid.component';
import { AgGridModule } from '@ag-grid-community/angular';
import { MaterialColorPickerModule } from 'app/main/shared/material-color-picker/material-color-picker.module';
import { PlResolver } from './pl.resolver';
import { EffectsModule } from '@ngrx/effects';
import { PlEffects, PlColumnEffects } from './effects';
import { StoreModule } from '@ngrx/store';
import { PageTitleModule } from 'app/layout/components/page-title/page-title.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { reducers } from './reducers';

@NgModule({
  imports: [
    CommonModule,
    MatToolbarModule,
    MatSlideToggleModule,
    FlexLayoutModule,
    MatFormFieldModule,
    FormsModule,
    MatSelectModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatRadioModule,
    MatInputModule,
    MaterialColorPickerModule,
    PageTitleModule,

    FuseSharedModule,
    
    // AG Grid
    AgGridModule.withComponents([]),
    EffectsModule.forFeature([PlEffects, PlColumnEffects]),
    StoreModule.forFeature('pl', reducers),
  ],
  declarations: [PlComponent, PlOptionsComponent, PlAggridComponent],
  exports: [PlComponent],
  providers: [PlResolver],
})
export class PlModule {}
